import { render } from "./NotPublished.vue?vue&type=template&id=bea385f6&scoped=true&ts=true"
import script from "./NotPublished.vue?vue&type=script&lang=ts"
export * from "./NotPublished.vue?vue&type=script&lang=ts"

import "./NotPublished.vue?vue&type=style&index=0&id=bea385f6&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bea385f6"]])

export default __exports__